import api from "./api";

const eventService = {
  // GET /api/events?month=&year=&academicYear=&type=
  getAll: (params) => api.get("/events", { params }).then((r) => r.data),

  // GET /api/events/upcoming?days=14&academicYear=
  getUpcoming: (params) =>
    api.get("/events/upcoming", { params }).then((r) => r.data),

  getById: (id) => api.get(`/events/${id}`).then((r) => r.data),

  create: (data) => api.post("/events", data).then((r) => r.data),

  update: (id, data) => api.put(`/events/${id}`, data).then((r) => r.data),

  remove: (id) => api.delete(`/events/${id}`).then((r) => r.data),
};

export default eventService;
